import React from 'react'
import CreateVariant from '../components/CreateVariant/CreateVariant'

const CreateVariantPage = () => {
    return <CreateVariant />
}

export default CreateVariantPage
